import Header from '../../header';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { getAuthElemStyle } from '../../../common/tools';
import { MainContext } from '../../../context/main.context';


export default function DeletionPersonalData(): JSX.Element {
    const { t } = useTranslation();
    const { settings } = useContext(MainContext);

    const _onMailClick = (): void => {
        window.open('mailto:support@playflock.com');
    }

    const _renderMenu = (): JSX.Element => {
        return (
            <div className="auth-modal-menu">
                <div className="deletion-personal-data" onClick={_onMailClick}>
                    {t('login.deletionPersonalData')}
                </div>
            </div>
        );
    }

    return (
        <div className="auth" id="auth-element-id">
            <div className="auth-modal" style={getAuthElemStyle(settings)}>
                <Header origin="auth"/>
                {_renderMenu()}
            </div>
        </div>
    );
}